import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SelectedGradeStateService } from '@app/infrastructure/core/services/state/selected-grade-state.service';
import { WYSIWYGBlock } from '@app/infrastructure/models/wysiwyg-block';
import { GradeLevel } from '@models/grade-level';
import { LanguageService } from '@core/services/languages.service';
import { takeUntil, switchMap } from 'rxjs/operators';
import { Subject, of, BehaviorSubject } from 'rxjs';
import { GetTranslationDto } from '@models/translation';
import { AlternateTextService } from '@core/services/alternate-text.service';
import { GetAlternateTextDTO } from '@models/alternate-text';

@Component({
  selector: 'app-wysiwyg-viewer',
  templateUrl: './wysiwyg-viewer.component.html',
  styleUrls: ['./wysiwyg-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WYSIWYGViewerComponent implements OnInit, OnDestroy {
  @Input() wysiwyg: WYSIWYGBlock = new WYSIWYGBlock();
  @Input() customStyle: string = null;
  public sanitizedHTML$: BehaviorSubject<SafeHtml> = new BehaviorSubject(null);
  public altTextUsed$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  set altTextUsed(value: boolean) {
    this.altTextUsed$.next(value);
  }

  private set sanitizedHTML(value: SafeHtml) {
    this.sanitizedHTML$.next(value);
  }
  gradeLevel: GradeLevel;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private sanitizer: DomSanitizer,
    private gradeState: SelectedGradeStateService,
    private languageService: LanguageService,
    private alternateTextService: AlternateTextService,
  ) {
    // this.gradeLevel = this.gradeState.gradeId;
  }

  ngOnInit(): void {
    // TODO: Sanitize HTML to make sure inline styles are used and not loading external styles
    this.gradeLevel = this.wysiwyg.gradeLevel;
    this.sanitizedHTML = this.sanitizer.bypassSecurityTrustHtml(
      this.wysiwyg.html,
    );

    this.languageService.activeLanguageAsObs$
      .pipe(
        takeUntil(this.onDestroy$),
        switchMap((lang: GetTranslationDto) => {
          if (!lang?.targetLanguage) {
            return of(null);
          } else {
            return this.alternateTextService.getAlternateText(
              this.wysiwyg.id,
              lang.targetLanguage,
            );
          }
        }),
      )
      .subscribe((altText: GetAlternateTextDTO) => {
        if (altText) {
          this.sanitizedHTML = this.sanitizer.bypassSecurityTrustHtml(
            altText.text,
          );
          this.altTextUsed = true;
        } else {
          this.sanitizedHTML = this.sanitizer.bypassSecurityTrustHtml(
            this.wysiwyg.html,
          );
          this.altTextUsed = false;
        }
      });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
